import { useDroppable } from "@dnd-kit/core";
import { Button, Icon, Loader } from "semantic-ui-react";

import { Can } from "components";
import { ACL_ACTIVITIES } from "models";
import { DraggableChecklistItem, LocationChecklistItem } from "modules/ChecklistsDashboard/components/ChecklistsList/components";
import { CHECKLIST_LISTS } from "modules/ChecklistsDashboard/util";
import { classNames } from "utils/common";

import type { ACL_RESOURCES, Checklist, ChecklistID } from "models";

type ChecklistsListProps = {
  list: CHECKLIST_LISTS;
  title: string;
  checklists: Checklist[];
  isLoading: boolean;
  isDroppable?: boolean;
  addResource?: ACL_RESOURCES;
  onChecklistClick: (checklistID: ChecklistID, list: CHECKLIST_LISTS) => void;
  onAdd?: () => void;
};

export const ChecklistsList = ({ list, title, checklists, isLoading, isDroppable, addResource, onChecklistClick, onAdd }: ChecklistsListProps) => {
  const { setNodeRef, isOver, active } = useDroppable({ id: list, disabled: !isDroppable });

  const isDropTarget = isOver && active?.data.current?.list !== list;

  const handleChecklistClick = (checklistID: ChecklistID) => onChecklistClick(checklistID, list);

  return (
    <div className="ChecklistsList">
      <div className="checklists-header">
        {addResource && onAdd && (
          <Can I={ACL_ACTIVITIES.Create} the={addResource}>
            <Button className="-appointment-status icon" size="small" onClick={onAdd}>
              <Icon className="plus" />
            </Button>
          </Can>
        )}
        <h3>{title}</h3>
      </div>

      <div ref={setNodeRef} className={`checklists-container ${classNames({ "is-drop-target": isDropTarget })}`}>
        {isLoading && <Loader active inline="centered" />}

        {!isLoading &&
          list === CHECKLIST_LISTS.Location &&
          checklists.map((checklist, checklistIdx) => (
            <LocationChecklistItem
              key={checklist.id}
              checklist={checklist}
              isFirst={checklistIdx === 0}
              isLast={checklistIdx === checklists.length - 1}
              onClick={handleChecklistClick}
            />
          ))}

        {!isLoading &&
          list !== CHECKLIST_LISTS.Location &&
          checklists.map(checklist => <DraggableChecklistItem key={checklist.id} checklist={checklist} list={list} onClick={handleChecklistClick} />)}

        {isDropTarget && <div className="drop-placeholder" />}
      </div>
    </div>
  );
};
